import { UUID } from '../../../../types/shared/UUID';
import { IEditSignerRequest } from '../../../../types/signingAppointment/IEditSignerRequest';
import { ISigningAppointmentEditFormData } from '../../../../types/signingAppointment/ISigningAppointmentEditFormData';

export interface NewSignerFormValues {
  id: UUID;
  signer: IEditSignerRequest;
}

export const buildRequest = (formData: NewSignerFormValues): ISigningAppointmentEditFormData => {
  return {
    id: formData.id,
    signers: [formData.signer],
  };
};
